'use client'

import { useEffect } from 'react'

export const DealersForm = () => {
  useEffect(() => {
    try {
      const f = document.createElement('iframe')
      f.src =
        'https://forms.zohopublic.com/vanishinginc/form/TheSession2023DealersApplication/formperma/MANY5d2fVMT1rPNjfjnnoI3657mE_S2HrszASHqBlVY?zf_rszfm=1'
      f.style.border = 'none'
      f.style.height = '1434px'
      f.style.width = '100%'
      f.style.transition = 'all 0.5s ease'
      const d = document.getElementById('zf_div_MANY5d2fVMT1rPNjfjnnoI3657mE_S2HrszASHqBlVY')
      if (d) {
        d.appendChild(f)

        window.addEventListener('message', function () {
          const evntData = (event as MessageEvent).data
          if (evntData && typeof evntData === 'string') {
            const zf_ifrm_data = evntData.split('|')
            if (zf_ifrm_data.length === 2) {
              const zf_perma = zf_ifrm_data[0]
              const zf_ifrm_ht_nw = parseInt(zf_ifrm_data[1], 10) + 15 + 'px'
              const container = document.getElementById(
                'zf_div_MANY5d2fVMT1rPNjfjnnoI3657mE_S2HrszASHqBlVY'
              )
              if (container) {
                const iframe = container.getElementsByTagName('iframe')[0]
                if (
                  iframe &&
                  iframe.src.indexOf('formperma') > 0 &&
                  iframe.src.indexOf(zf_perma) > 0
                ) {
                  const prevIframeHeight = iframe.style.height
                  if (prevIframeHeight !== zf_ifrm_ht_nw) {
                    iframe.style.height = zf_ifrm_ht_nw
                  }
                }
              }
            }
          }
        })
      }
    } catch (e) {
      console.error('Error loading dealers form:', e)
    }
  }, [])

  return <div id="zf_div_MANY5d2fVMT1rPNjfjnnoI3657mE_S2HrszASHqBlVY"></div>
}

